'use client';

import { useState, useEffect } from 'react';
import ContactHero from './ContactHero';
import ContactMethods from './ContactMethods';
import ContactForm from './ContactForm';
import ServiceAreaMap from './ServiceAreaMap';
import BusinessHours from './BusinessHours';
import TrustSignals from './TrustSignals';
import Icon from '@/components/ui/AppIcon';

const ContactInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState<'fr' | 'de'>('fr');

  useEffect(() => {
    setIsHydrated(true);
    const savedLanguage = localStorage.getItem('preferredLanguage') as 'fr' | 'de' | null;
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const handleLanguageChange = (lang: 'fr' | 'de') => {
    setCurrentLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="h-screen flex items-center justify-center">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Language Switcher */}
      <div className="fixed top-20 right-4 z-40 bg-card shadow-lg rounded-lg p-2 border border-border">
        <div className="flex gap-2">
          <button
            onClick={() => handleLanguageChange('fr')}
            className={`px-4 py-2 rounded-md font-medium transition-all duration-300 ${
              currentLanguage === 'fr' ?'bg-primary text-white' :'bg-surface text-muted-foreground hover:bg-muted'
            }`}
          >
            FR
          </button>
          <button
            onClick={() => handleLanguageChange('de')}
            className={`px-4 py-2 rounded-md font-medium transition-all duration-300 ${
              currentLanguage === 'de' ?'bg-primary text-white' :'bg-surface text-muted-foreground hover:bg-muted'
            }`}
          >
            DE
          </button>
        </div>
      </div>

      {/* Quick Contact Floating Button */}
      <a
        href="tel:+41762126506"
        className="fixed bottom-8 right-8 z-40 flex items-center justify-center w-16 h-16 bg-accent hover:bg-accent/90 text-accent-foreground rounded-full shadow-2xl hover:scale-110 transition-all duration-300 group"
        aria-label="Call us"
      >
        <Icon name="PhoneIcon" size={28} variant="solid" className="group-hover:animate-pulse" />
      </a>

      <ContactHero currentLanguage={currentLanguage} />
      <ContactMethods currentLanguage={currentLanguage} />
      <ContactForm currentLanguage={currentLanguage} />
      <ServiceAreaMap currentLanguage={currentLanguage} />
      <BusinessHours currentLanguage={currentLanguage} />
      <TrustSignals currentLanguage={currentLanguage} />
    </div>
  );
};

export default ContactInteractive;